import React from "react";
import calender from "../../../../assets/images/calender.png";
import utr from "../../../../assets/images/utr.png";
import rupee from "../../../../assets/images/rupee.png";
import { formatToIndianRupees } from "../../../../utils/formatToIndianRupees";
export default function Disbursal(props) {
  const { applicationDetails, decode } = props;

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        <div
          style={{
            height: "100px",
            boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.4)",
            borderColor: "#EAECF0",
            borderRadius: "5px",
            padding: "10px",
            borderStyle: "solid",
            borderWidth: "1px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "280px",
            justifyContent: "space-between",
          }}
        >
          <div>
            <p
              style={{
                lineHeight: "5px",
                fontFamily: "Inter-Medium",
                color: "#858585",
                fontWeight: "500",
              }}
            >
              Amount Disbursed
            </p>
            <p
              style={{
                lineHeight: "30px",
                color: "#101828",
                fontWeight: "600",
                fontFamily: "Inter-Medium",
                fontSize: "15px",
              }}
            >
              {applicationDetails &&
              applicationDetails?.profile?.disbursementData &&
              applicationDetails?.profile?.disbursementData?.disbursedAmount
                ? formatToIndianRupees(
                    applicationDetails?.profile?.disbursementData
                      ?.disbursedAmount
                  )
                : "-------"}
            </p>
          </div>
          <span>
            <img
              src={rupee}
              alt="rupee"
              style={{ height: "53px", width: "53px" }}
            />
          </span>
        </div>
        <div
          style={{
            height: "100px",
            boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.4)",
            borderColor: "#EAECF0",
            borderRadius: "5px",
            padding: "10px",
            borderStyle: "solid",
            borderWidth: "1px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "280px",
            justifyContent: "space-between",
          }}
        >
          <div>
            <p
              style={{
                lineHeight: "5px",
                fontFamily: "Inter-Medium",
                color: "#858585",
                fontWeight: "500",
              }}
            >
              Disbursement Date
            </p>
            {/* <p style={{lineHeight:'30px',color:'#101828',fontWeight:'600',fontFamily:'Inter-Medium',fontSize:'15px'}}>{applicationDetails?applicationDetails.profile.disbursementData.disbursedData.slice(0, 10).replace(/-/g, "/"):null}</p> */}
            <p
              style={{
                lineHeight: "30px",
                color: "#101828",
                fontWeight: "600",
                fontFamily: "Inter-Medium",
                fontSize: "15px",
              }}
            >
              {applicationDetails?.profile?.disbursementData?.disbursedDate?.substr(
                0,
                10
              )}
            </p>
          </div>
          <span>
            <img
              src={calender}
              alt="calender"
              style={{ height: "53px", width: "53px" }}
            />
          </span>
        </div>
        <div
          style={{
            height: "100px",
            boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.4)",
            borderColor: "#EAECF0",
            borderRadius: "5px",
            padding: "10px",
            borderStyle: "solid",
            borderWidth: "1px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "280px",
            justifyContent: "space-between",
          }}
        >
          <div>
            <p
              style={{
                lineHeight: "5px",
                fontFamily: "Inter-Medium",
                color: "#858585",
                fontWeight: "500",
              }}
            >
              UTR
            </p>
            <p
              style={{
                lineHeight: "30px",
                color: "#101828",
                fontWeight: "600",
                fontFamily: "Inter-Medium",
                fontSize: "15px",
              }}
            >
              {applicationDetails &&
              applicationDetails?.profile?.disbursementData &&
              applicationDetails?.profile?.disbursementData?.utr
                ? applicationDetails?.profile?.disbursementData?.utr
                : "-------"}
            </p>
          </div>
          <span>
            <img
              src={utr}
              alt="utr"
              style={{ height: "53px", width: "60px" }}
            />
          </span>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            borderRadius: "1em",
            width: "100%",
            margin: "1em",
            boxShadow: "0px 0px 2px 2px #f0f0f0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1em",
              width: "100%",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                fontFamily: "Outfit",
                margin: "0",
              }}
            >
              Disbursement Breakup:
            </h2>
          </div>
          <div style={{ padding: "1em" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ width: "25%" }}>
                <p style={{ color: "#667085", textAlign: "center" }}>Type :</p>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  {applicationDetails?.profile?.productData?.facilityType
                    ? applicationDetails?.profile?.productData?.facilityType ===
                      1
                      ? "Discounted Interest"
                      : applicationDetails?.profile?.productData
                          ?.facilityType === 2
                      ? "Standard Interest"
                      : applicationDetails?.profile?.productData
                          ?.facilityType === 3
                      ? "Hybrid"
                      : applicationDetails?.profile?.productData
                          ?.facilityType === 4
                      ? "Business 2 Business"
                      : applicationDetails?.profile?.productData
                          ?.facilityType === 4
                      ? "Discounted Interest Without Gst"
                      : applicationDetails?.profile?.productData?.facilityType
                    : applicationDetails?.profile?.productData?.facilityType}
                </p>
              </div>
              <div style={{ width: "25%" }}>
                <p style={{ color: "#667085", textAlign: "center" }}>
                  {" "}
                  Discounted Intrst % :
                </p>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  {applicationDetails?.profile?.productData
                    ?.discountedInterestPercentage
                    ? (applicationDetails?.profile?.productData?.discountedInterestPercentage).toFixed(
                        2
                      )
                    : "-"}
                </p>
              </div>
              <div style={{ width: "25%" }}>
                <p style={{ color: "#667085", textAlign: "center" }}>
                  Tenure :
                </p>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  {applicationDetails?.profile?.productData?.tenure
                    ? applicationDetails?.profile?.productData?.tenure
                    : "-"}
                </p>
              </div>
              <div style={{ width: "25%" }}>
                <p style={{ color: "#667085", textAlign: "center" }}>
                  Processing Fee Type :
                </p>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  {applicationDetails?.profile?.productData?.processingfeeType
                    ? applicationDetails?.profile?.productData
                        ?.processingfeeType === 1
                      ? "Flat"
                      : applicationDetails?.profile?.productData
                          ?.processingfeeType === 2
                      ? "Percentage"
                      : applicationDetails?.profile?.productData
                          ?.processingfeeType
                    : applicationDetails?.profile?.productData
                        ?.processingfeeType}
                </p>
              </div>
              <div style={{ width: "25%" }}>
                <p style={{ color: "#667085", textAlign: "center" }}>
                  Processing Fee :
                </p>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  {applicationDetails &&
                  applicationDetails?.profile?.disbursementData &&
                  applicationDetails?.profile?.disbursementData?.processingFee
                    ? formatToIndianRupees(
                        applicationDetails?.profile?.disbursementData
                          ?.processingFee
                      )
                    : 0}
                </p>
              </div>
              <div style={{ width: "25%", textAlign: "center" }}>
                <p style={{ color: "#667085" }}>Processing Fee GST :</p>
                <p style={{ fontWeight: "bold" }}>
                  {applicationDetails &&
                  applicationDetails?.profile?.disbursementData &&
                  applicationDetails?.profile?.disbursementData
                    ?.processingFeeGst
                    ? formatToIndianRupees(
                        applicationDetails?.profile?.disbursementData
                          ?.processingFeeGst
                      )
                    : 0}
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ width: "25%" }}>
                <p style={{ color: "#667085", textAlign: "center" }}>
                  Subvention :
                </p>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  {applicationDetails &&
                  applicationDetails?.profile?.disbursementData &&
                  applicationDetails?.profile?.disbursementData?.subvention
                    ? formatToIndianRupees(
                        applicationDetails?.profile?.disbursementData
                          ?.subvention
                      )
                    : 0}
                </p>
              </div>
              <div style={{ width: "25%", textAlign: "center" }}>
                <p style={{ color: "#667085" }}>Subvention GST:</p>
                <p style={{ fontWeight: "bold" }}>
                  {applicationDetails &&
                  applicationDetails?.profile?.disbursementData &&
                  applicationDetails?.profile?.disbursementData?.subventionGst
                    ? formatToIndianRupees(
                        applicationDetails?.profile?.disbursementData
                          ?.subventionGst
                      )
                    : "0"}
                </p>
              </div>
              <div style={{ width: "25%" }}>
                <p style={{ color: "#667085", textAlign: "center" }}>
                  Advance EMI :
                </p>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  {applicationDetails?.profile?.productData?.advanceEmis
                    ? applicationDetails?.profile?.productData?.advanceEmis
                    : "0"}
                </p>
              </div>
              <div style={{ width: "25%", textAlign: "center" }}>
                <p style={{ color: "#667085" }}>Advance EMI Amount:</p>
                <p style={{ fontWeight: "bold" }}>
                  {applicationDetails &&
                  applicationDetails?.profile?.disbursementData &&
                  applicationDetails?.profile?.disbursementData
                    ?.advanceEmiAmount
                    ? formatToIndianRupees(
                        applicationDetails?.profile?.disbursementData
                          ?.advanceEmiAmount
                      )
                    : "0"}
                </p>
              </div>
              <div style={{ width: "25%", textAlign: "center" }}>
                <p style={{ color: "#667085" }}>fldg Applicable:</p>
                <p style={{ fontWeight: "bold" }}>
                  {applicationDetails?.profile?.productData?.fldgApplicable
                    ? applicationDetails?.profile?.productData
                        ?.fldgApplicable === true
                      ? "Yes"
                      : applicationDetails?.profile?.productData
                          ?.fldgApplicable === false
                      ? "No"
                      : "No"
                    : "No"}
                </p>
              </div>
              <div style={{ width: "25%", textAlign: "center" }}>
                <p style={{ color: "#667085" }}>fldg Percentage:</p>
                <p style={{ fontWeight: "bold" }}>
                  {applicationDetails?.profile?.productData?.fldgPercentage
                    ? applicationDetails?.profile?.productData?.fldgPercentage
                    : "0"}
                </p>
              </div>
              {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                <div style={{ width: "25%", textAlign: "center" }}>
                  <p style={{ color: "#667085" }}>Customer Insurance Amount + GST :</p>
                  <p style={{ fontWeight: "bold" }}>
                    {applicationDetails?.profile?.productData
                      ?.customerInsuranceAmount
                      ? formatToIndianRupees(
                          applicationDetails?.profile?.productData
                            ?.customerInsuranceAmount
                        )
                      : "0"}
                  </p>
                </div>
              )}
              {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                <div style={{ width: "25%", textAlign: "center" }}>
                  <p style={{ color: "#667085" }}>Document Charges Type :</p>
                  <p style={{ fontWeight: "bold" }}>
                    {applicationDetails?.profile?.productData?.documentChargesType === 1
                      ? "Flat"
                      : applicationDetails?.profile?.productData?.documentChargesType === 2
                      ? "Percentage"
                      : "-"}
                  </p>
                </div>
              )}
              {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                <div style={{ width: "25%", textAlign: "center" }}>
                  <p style={{ color: "#667085" }}>Document Charges + GST :</p>
                  <p style={{ fontWeight: "bold" }}>
                    {applicationDetails?.profile?.productData?.documentChargesValueGst
                      ? formatToIndianRupees(
                          applicationDetails?.profile?.productData?.documentChargesValueGst
                        )
                      : "0"}
                  </p>
                </div>
              )}
              {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                <div style={{ width: "25%", textAlign: "center" }}>
                  <p style={{ color: "#667085" }}>Stamp Duty :</p>
                  <p style={{ fontWeight: "bold" }}>
                    {applicationDetails?.profile?.productData?.stampDuty
                      ? formatToIndianRupees(
                          applicationDetails?.profile?.productData?.stampDuty
                        )
                      : "0"}
                  </p>
                </div>
              )}
              {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                <div style={{ width: "25%", textAlign: "center" }}>
                  <p style={{ color: "#667085" }}>Admin Charges + GST :</p>
                  <p style={{ fontWeight: "bold" }}>
                    {applicationDetails?.profile?.productData?.otherCharges
                      ? formatToIndianRupees(
                          applicationDetails?.profile?.productData?.otherCharges
                        )
                      : "0"}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
